const dcrypt = (array, characters) => {
  let b = array;
  let c = [];
  let temp = [];
  let y = parseInt(b.length / 2 + 0.6);
  let count = b.length;
  y--;
  for (let i = 0; i <= y; i++) {
    if (count > 0) {
      temp.push(b[i]);
      count--;
    }
    if (count > 0) {
      temp.push(b[parseInt(y) + parseInt(i) + parseInt(1)]);
      count--;
    }
  }
  for (let k = 0; k < temp.length; k++) {
    let x = characters.indexOf(temp[k]);
    if (x === -1) {
      c.push(temp[k]);
    } else {
      c.push(
        characters[
          (characters.length + x - (k % characters.length)) % characters.length
        ]
      );
    }
  }
  return c;
};
const encrypt = (array, characters) => {
  let a = array;
  let b = [];
  for (let i = 0; i < a.length; i++) {
    if (i % 2 === 0) {
      let x = characters.indexOf(a[i]);
      if (x === -1) {
        b.push(a[i]);
      } else {
        b.push(characters[(x + i) % characters.length]);
      }
    }
  }
  for (let i = 0; i < a.length; i++) {
    if (i % 2 !== 0) {
      let x = characters.indexOf(a[i]);
      if (x === -1) {
        b.push(a[i]);
      } else {
        b.push(characters[(x + i) % characters.length]);
      }
    }
  }
  return b;
};
export { encrypt, dcrypt };
